
export default function ServicesGrid() {
  const services = [
    {
      icon: 'ri-robot-2-line',
      title: 'Process Automation',
      description: 'Streamline repetitive tasks with intelligent workflows that handle data entry, email responses, and routine operations automatically.',
      features: ['Data Processing', 'Email Automation', 'Document Generation', 'Task Scheduling']
    },
    {
      icon: 'ri-brain-line',
      title: 'AI Chatbots & Assistants',
      description: 'Deploy smart conversational AI that handles customer inquiries, bookings, and support requests 24/7 with human-like responses.',
      features: ['Customer Support', 'Lead Qualification', 'Appointment Booking', 'FAQ Automation']
    }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-white to-[#EBEBE0]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-[#182114] mb-6" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
            Our <span className="text-[#AFC4E4]">Automation</span> Services
          </h2>
          <div className="w-24 h-1 bg-[#AFC4E4] mx-auto mb-8"></div>
          <p className="text-xl text-[#2E3F25] max-w-3xl mx-auto" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
            From simple task automation to complex AI integrations, we build solutions that scale with your business.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#AFC4E4] to-[#9BB5D9] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-[#182114] mb-4" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
                {service.title}
              </h3>
              
              <p className="text-[#2E3F25] leading-relaxed mb-6" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
                {service.description}
              </p>

              <div className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#AFC4E4] rounded-full"></div>
                    <span className="text-sm text-[#2E3F25]" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
                      {feature}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
